import { useEffect, useRef, useState } from 'react';
export const useTargetWindow = () => {
  const targetFrameRef = useRef(null);
  const [targetWindow, setTargetWindow] = useState(null);
  useEffect(() => {
    if (targetFrameRef.current) {
      setTargetWindow(targetFrameRef.current.contentWindow);
    }
  }, [targetFrameRef]);
  return {
    targetFrameRef,
    targetWindow
  };
};